import { render, staticRenderFns } from "./VeJwJingsaiCheckPersonalModal.vue?vue&type=template&id=2fffa96b"
import script from "./VeJwJingsaiCheckPersonalModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiCheckPersonalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports